import { GetServerSideProps, NextPage } from 'next'
import { GlobalRequest } from '~/components/global-request'
import { MyContainer } from '~/components/ui/MyContainer'
import { Layout } from '~/layouts/default'
import { AGREEMENT_PRFIX_KEY } from '~/configs'

import * as api from '~/apis'
import { PageCrumbs } from '~/components/business/PageCrumbs'
import { SEOHead } from '~/components/business/SEOHead'
import { HtmlContent } from '~/components/ui/HtmlContent'

const Page: NextPage<{
  data: any
}> = ({ data }) => {
  return (
    <Layout>
      <SEOHead title="AI创作服务协议" />
      <MyContainer>
        <PageCrumbs title="AI创作服务协议" center dark />
        <HtmlContent data={data.content} />
      </MyContainer>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState } = await GlobalRequest(context)
  const dataRes = await api.getConfig({
    data: {
      key: AGREEMENT_PRFIX_KEY + '.aiAgreement',
    },
  })

  return {
    props: {
      initialState,
      data: JSON.parse(dataRes.data.data) || {},
    },
  }
}

export default Page
